import withAemIntegration from "../../../withAemIntegration";

const EditConfig = {
  emptyLabel: 'My Lexus - Benefits and Destinations',
  isEmpty: function(props) {
    return !props || !props.title || props.title.trim().length < 1;
  }
};

const Render = (props) => {
  return <div/>;
}

export default withAemIntegration('lexus/components/content/my-lexus/benefits-and-destinations')(Render, EditConfig);
